import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { getEnvVar } from '../utils/getEnvVar';

const FuelUpgradeBanner = () => {
  if (getEnvVar('VITE_ENV') !== 'prod') {
    return null;
  }

  return (
    <Alert severity="informational">
      <AlertTitle>New Look, Same Functionality</AlertTitle>
      DMSM has been updated to the latest Fuel UI framework. You may notice
      visual changes, but all functionality remains unchanged.
    </Alert>
  );
};

export default FuelUpgradeBanner;

